import { CoordinatorService } from "./coordinator.service"
import { Databin } from "./databin"
import { View } from "./view"

export class EditField {
    isEditOn = false
    source?: string
    id: string

    constructor(private coords: CoordinatorService,
        public tag: string,
        // private _valueMap: Map<string, any>,
        private target: View | Databin
    ) {
        this.id = this.coords.uniqueId()
    }

    get value() {
        return this.target.get(this.tag) || ""
    }

    edit() {
        this.isEditOn = true
        this.source = this.value
        setTimeout(() =>
            document.getElementById(this.id)?.focus(), 200)
    }

    get submitParams() {
        return {
            bLs: [
                {
                    icon: "cancel",
                    fun: () => this.isEditOn = false
                }, {
                    icon: "confirm",
                    fun: () => {
                        this.source = this.source!.trim()
                        if (!this.source) return
                        this.target.set(this.tag, this.source)
                        this.isEditOn = false
                        // this.coords.project$.store()
                    }
                }]
        }
    }
}
